export const TEXTURE = "https://customer-assets-cm19k8pv.emergentagent.net/job_efb10a18-7d88-474f-a856-696fd7fbea61/artifacts/735f9ea8c4346223_media-generation-nagel-background-no-logo-png-0-36c2aceb-422c-4bd8-aa41-fe59ef74d17b.png";
export const LOGO_BLACK = "https://customer-assets-cm19k8pv.emergentagent.net/job_efb10a18-7d88-474f-a856-696fd7fbea61/artifacts/aefcaeb0f6c2758b_BLACK.png";
export const LOGO_WHITE = "https://customer-assets-m6fa6gv7.emergentagent.net/job_pixel-landscape-ca/artifacts/1e043c901ea45013_14.png";
export const LOGO_MARK = "https://customer-assets-m6fa6gv7.emergentagent.net/job_pixel-landscape-ca/artifacts/518def0753ecb2fc_16.png";

export const IMG = {
  hero: "https://images.unsplash.com/photo-1615931982700-4b4dcc3835bd?crop=entropy&cs=srgb&fm=jpg&q=85",
  brandTall: "https://images.unsplash.com/photo-1563714193017-5a5fb60bc02b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxlZGl0b3JpYWwlMjBnYXJkZW4lMjBwYXRofGVufDB8fHx8MTc5MTQ1OTA4NXww&ixlib=rb-4.1.0&q=85",
  brandSmall: "https://images.unsplash.com/photo-1599685315640-9ceab2f58148?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxnYXJkZW4lMjBwYXRoJTIwdHJlZXN8ZW58MHx8fHwxNzkxNDU4OTkzfDA&ixlib=rb-4.1.0&q=85",
  storyMain: "https://images.unsplash.com/photo-1713383658268-6b9bd03beb19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxnYXJkZW4lMjBwYXRoJTIwdHJlZXN8ZW58MHx8fHwxNzkxNDU4OTkzfDA&ixlib=rb-4.1.0&q=85",
  storySmall: "https://images.unsplash.com/photo-1759390304699-5c389476ca80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxlZGl0b3JpYWwlMjBnYXJkZW4lMjBwYXRofGVufDB8fHx8MTc5MTQ1OTA4NXww&ixlib=rb-4.1.0&q=85",
};

export const TRUST_ITEMS = [
  "54 YEARS IN BUSINESS",
  "24 CALIFORNIA COUNTIES",
  "33,000+ SQUARE MILES SERVED",
  "40+ YEARS OF DESIGN-BUILD EXPERIENCE",
  "CA LICENSE #667661",
];

export const CLIENTS = [
  "Hilmar Cheese",
  "Regal Cinemas",
  "Texas Roadhouse",
  "Holiday Inn Express & Suites",
  "In-Shape",
  "Community Hospice",
  "Village West Retail Center",
  "Modesto Toyota",
  "VP Racing",
];

export const SERVICES = [
  {
    num: "01",
    name: "LANDSCAPE CONSTRUCTION",
    title: "Built from the ground up.",
    copy: ["From irrigation and planting to hardscape, lighting, outdoor structures and specialty installations, Nagel handles the details that turn a plan into a finished landscape."],
    cta: "EXPLORE LANDSCAPE CONSTRUCTION",
    img: "https://images.unsplash.com/photo-1790426540560-081e8c62c563?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxsYW5kc2NhcGUlMjBhcmNoaXRlY3R1cmUlMjBtb2Rlcm4lMjBjb3VydHlhcmQlMjBwbGF6YSUyMGVkaXRvcmlhbHxlbnwwfHx8fDE3OTE0NDY1MTR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    num: "02",
    name: "LANDSCAPE DESIGN-BUILD",
    title: "Design with the build in mind.",
    copy: ["Our design-build approach brings design and construction together from the beginning — creating landscapes that are functional, visually considered and built around the way each property is meant to be used."],
    cta: "EXPLORE DESIGN-BUILD",
    img: "https://images.unsplash.com/photo-1668120089662-42642838cfef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxsYW5kc2NhcGUlMjBnYXJkZW4lMjBkZXNpZ258ZW58MHx8fHwxNzkxNDU5MDg1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    num: "03",
    name: "LANDSCAPE MANAGEMENT",
    title: "Built to last. Maintained to stay that way.",
    copy: ["A finished landscape is only the beginning.", "Nagel provides ongoing landscape management designed to protect the appearance, health and long-term value of the property."],
    cta: "EXPLORE LANDSCAPE MANAGEMENT",
    img: "https://images.unsplash.com/photo-1641317430847-243b44c07125?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxtYW5pY3VyZWQlMjBnYXJkZW4lMjBsYXdufGVufDB8fHx8MTc5MTQ1OTA4Nnww&ixlib=rb-4.1.0&q=85",
  },
];

export const PROJECTS = [
  {
    title: "HILMAR CHEESE ADMIN. BUILDING",
    location: "Hilmar, California",
    img: "https://images.unsplash.com/photo-1615931982700-4b4dcc3835bd?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "HOLIDAY INN EXPRESS & SUITES",
    location: "Modesto, California",
    img: "https://images.unsplash.com/photo-1587541984362-f1cbdce5a3c1?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "VILLAGE WEST RETAIL CENTER",
    location: "Modesto, California",
    img: "https://images.unsplash.com/photo-1561283890-5d858c23b2ea?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "VILLETTAS @ TESORO STREETSCAPE",
    location: "Oakdale, California",
    img: "https://images.unsplash.com/photo-1668120089662-42642838cfef?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "PILLSBURY ESTATES PARK",
    location: "Manteca, California",
    img: "https://images.unsplash.com/photo-1641317430847-243b44c07125?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "CROTHALL LAUNDRY SERVICE",
    location: "Manteca, California",
    img: "https://images.unsplash.com/photo-1790426540560-081e8c62c563?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const STATS = [
  { value: 54, suffix: "+", label: "YEARS", desc: "Serving Northern & Central California since 1972." },
  { value: 24, suffix: "", label: "COUNTIES", desc: "A regional footprint built over five decades." },
  { value: 33000, suffix: "+", label: "SQUARE MILES", desc: "Across the Central Valley, Bay Area and surrounding regions." },
  { value: 40, suffix: "+", label: "YEARS OF DESIGN-BUILD", desc: "Experience bringing design and construction together." },
];

export const WHY_ITEMS = [
  { title: "ONE CONNECTED TEAM", copy: "Design, construction and landscape management under one roof." },
  { title: "REGIONAL KNOWLEDGE", copy: "Decades of experience building landscapes throughout Northern and Central California." },
  { title: "BUILT FOR THE LONG TERM", copy: "We think beyond installation — considering how every landscape will perform, age and be maintained." },
  { title: "PROVEN ACROSS PROJECT TYPES", copy: "Commercial properties, residential estates, parks, streetscapes, sports facilities, retail centers and more." },
  { title: "HONEST WORK", copy: "Quality service, fair pricing and a commitment to honesty and integrity have been part of Nagel's stated mission since its earliest years." },
];

export const TIMELINE = [
  { year: "1972", text: "Nagel Landscaping begins in Modesto, California." },
  { year: "1989", text: "Don Owens joins the company." },
  { year: "1993", text: "Don becomes Vice President." },
  { year: "2003", text: "Don and Gina Owens acquire the company." },
  { year: "TODAY", text: "More than five decades of landscape construction, design-build and management." },
];

export const FAQS = [
  {
    q: "What services does Nagel Landscaping provide?",
    a: "Nagel Landscaping provides commercial and residential landscape construction, design-build and landscape management services throughout Northern and Central California.",
  },
  {
    q: "Does Nagel work with commercial properties?",
    a: "Yes. Nagel works across a wide range of commercial and institutional environments, including retail properties, business facilities, hospitality, parks, streetscapes and other developed spaces.",
  },
  {
    q: "Does Nagel provide landscape design?",
    a: "Yes. Nagel has an in-house design team and works with consulting landscape architects as part of its design-build services.",
  },
  {
    q: "What areas does Nagel Landscaping serve?",
    a: "Nagel serves Northern and Central California, covering more than 33,000 square miles across 24 counties.",
  },
  {
    q: "How long has Nagel Landscaping been in business?",
    a: "Nagel Landscaping was founded in 1972 and has been serving California for more than five decades.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "Nagel took our property from a set of drawings to a landscape that changes how people experience the building every single day.",
    author: "Facilities Director",
    org: "Corporate Campus, Central Valley",
  },
  {
    quote: "One team from design through construction meant no finger-pointing and no surprises. The finished landscape speaks for itself.",
    author: "Development Manager",
    org: "Retail Center, Modesto",
  },
  {
    quote: "Five years after installation, the grounds still look like the day the project was completed. That is what long-term thinking looks like.",
    author: "Property Manager",
    org: "Hospitality Property, Northern California",
  },
];

export const REGIONS = [
  { id: "central-valley", label: "Central Valley", detail: "Modesto • Manteca • Turlock • Ripon • Stockton • Oakdale • Merced • Patterson" },
  { id: "bay-area", label: "Bay Area & Surrounding Regions", detail: "Including communities throughout Nagel's broader Northern California service area." },
];
